import BasePatient from 'interfaces/Patient';
import User from 'interfaces/User';
import baseIsPatient from 'shared/utils/isPatient';

export default function isPatient(user: User | null): user is BasePatient {
  if (!user) {
    return false;
  }
  return baseIsPatient(user);
}
